module.exports = __webpack_public_path__ + "img/P56-zh.12defc2d.png";